import { render, staticRenderFns } from "./freezePersonnel.vue?vue&type=template&id=ad99d198&"
import script from "./freezePersonnel.vue?vue&type=script&lang=js&"
export * from "./freezePersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports